import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NewsletterFormComponentDef } from '@df/session/newsletter/newsletter-form.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ActionComponent } from '../ui/api/action.component';
import { ResultComponent } from '../ui/api/result.component';
import { CheckboxComponent } from '../ui/form/checkbox';
import { InputWrapBodyDirective } from '../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../ui/form/input-wrap.component';
import { ValidatePatternAsyncDirective } from '../ui/form/validate/validate-pattern-acync.directive';

@Component({
    selector: 'newsletter-form',
    templateUrl: './newsletter-form.component.html',
    styleUrl: './newsletter-form.component.scss',
    standalone: true,
    imports: [
        ActionComponent,
        CheckboxComponent,
        CommonModule,
        FormsModule,
        InputWrapBodyDirective,
        InputWrapComponent,
        ResultComponent,
        TranslatePipe,
        ValidatePatternAsyncDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterFormComponent extends NewsletterFormComponentDef implements OnInit, AfterViewInit {
    @Input()
    termsCopy?: string;

    @Input()
    ctaCopy?: string;

    @Input()
    hidePrivacyPolicy?: boolean;

    @Input()
    footerNewsletter?: boolean;

    @ViewChild('emailRef', { static: false })
    emailRef!: ElementRef<HTMLInputElement>;

    protected isPending = false;

    override ngAfterViewInit(): void {
        this.subscriptions.add(this.form?.statusChanges?.subscribe(event => this.updateClass(event)));
    }

    handleKeyUp(event?: KeyboardEvent) {
        if (event?.key === 'Enter') {
            this._submit();
        }

        if (this.form) {
            if (event && this.form['submitAttempt'] && !this.data?.email?.length) {
                this.form['submitAttempt'] = false;

                this.detectChanges();
            } else if (!event && this.data?.email?.length) {
                if (!this.form['submitAttempt']) {
                    this.form['submitAttempt'] = true;
                    this.form.ngSubmit.emit();
                }

                this.detectChanges();
            }
        }
    }

    protected updateClass(event: 'PENDING' | 'INVALID' | 'VALID') {
        this.isPending = event === 'PENDING';

        this.detectChanges();
    }
}
